import { useCallback } from "react";
import { HexColorInput } from "react-colorful";

import { Color, Container, Label } from "./styles";

interface Props {
  label?: string;
  onClick?: () => void;
  onChange?: (color: string) => void;
  color: string;
  active?: boolean;
  onlyPreview?: boolean;
  /** Shown right after the label (e.g. the PLUS tag). */
  tag?: React.ReactNode;
}

const InputColor = ({ label, onClick, onChange, color, active, onlyPreview, tag }: Props) => {
  const onClickHandler = useCallback(() => {
    if (onClick && active) {
      onClick();
    }
  }, [onClick, active]);
  const onChangeHandler = useCallback(
    (color: string) => {
      if (onChange) {
        onChange(color);
      }
    },
    [onChange]
  );

  return (
    <Container>
      {label && (
        <span className="label">
          <Label>{label}</Label>
          {tag}
        </span>
      )}
      <Color role="button" color={color} onClick={onClickHandler} hasClick={active! && onlyPreview! && !!onClick}>
        {onlyPreview && color}
        {!onlyPreview && <HexColorInput prefixed color={color} onChange={onChangeHandler} aria-label={label} />}
      </Color>
    </Container>
  );
};

export default InputColor;
